import { Button } from 'antd'
import React from 'react'

function TextButton({children}) {
  return (
    <Button type="text" className='auf-button'>{children}</Button>
  )
}

export default TextButton